import { AUTH_POST } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

export interface CheckForMergeRequest {
    fullName: string;
    phone?: Array<{
        countryCode: string;
        number: string;
        type: string;
        default: boolean;
    }>;
    email?: Array<{
        id: string;
        type: string;
        default: boolean;
    }>;
}

export const checkForMerge = async (requestBody: CheckForMergeRequest): Promise<any[]> => {
    try {
        const url = new URL("/api/leads/check-for-merge", config.baseURL);

        const response = await AUTH_POST(url.toString(), requestBody);
        return response;
    } catch (error) {
        console.error("Error checking for lead merge:", error);
        throw error;
    }
};
